<template>
  <div class="page-about content">
    <div class="page-about__content">
      <SectionHeader :title="$t('promo.about.section_header')" />
      <h2 class="page-about__title">{{ $t('promo.about.title') }}</h2>
      <p class="page-about__text">{{ $t('promo.about.text') }}</p>
    </div>
    <div class="page-about__video">
      <video
        preload="auto"
        muted=""
        autoplay="auto"
        loop="loop"
        data-keepplaying=""
        playsinline
        :poster="require('../images/page-about-video-bg.webp')"
      >
        <source :src="introBgVideo.mp4" type="video/mp4" />
      </video>
      <VideoButton class="page-about__video-button" @click="$emit('click')" />
    </div>
  </div>
</template>

<script>
import SectionHeader from "@static_promo_pages/common/components/redesign/section-header/vue/SectionHeader.vue";
import VideoButton from "@static_promo_pages/common/components/redesign/video-button/vue/VideoButton.vue";

import DeviceDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/DeviceDetectionMixin";

export default {
  name: "PageAbout",
  components: {
    SectionHeader,
    VideoButton,
  },
  mixins: [DeviceDetectionMixin],
  computed: {
    introBgVideo() {
      return {
        mp4: require("../videos/page-about-video.mp4"),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles";
</style>
